export default {
  SET_CURRENT_APPLICATION(state, data) {
    state.currentApplication = data
  },
  CLEAR_CURRENT_APPLICATION(state) {
    state.currentApplication = null
  },

  // Application report chart
  SET_CURRENT_REPORT(state, data) {
    state.currentReport = data
  },
  CLEAR_CURRENT_REPORT(state) {
    state.currentReport = null
  },
}
